import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const atomGlobalAudioStreamingOn = atom(false);
export const atomGlobalAudioLocalOn = atomWithStorage("@Eriol/audio/local-enabled", false);
